import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
interface ProtectedRouteProps {
  children: React.ReactNode;
}
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children
}) => {
  const {
    currentUser,
    loading
  } = useAuth();
  if (loading) {
    return <div className="flex justify-center items-center h-screen" data-id="element-259">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" data-id="element-260"></div>
      </div>;
  }
  if (!currentUser) {
    return <Navigate to="/login" data-id="element-261" />;
  }
  return <>{children}</>;
};